import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { SharedService } from '../modules/shared/services/shared.service';

@Injectable({
  providedIn: 'root'
})
export class LandingRedirectGuard implements CanActivate {

  constructor(
    private sharedSvc: SharedService,
    private router: Router,
  ) {}

  canActivate(): boolean | UrlTree {
    const defaultRoute = this.sharedSvc.configDetails?.defaultRoute;

    // If defaultRoute is empty or not set, allow the default component (PublicHomeComponent) to load
    if (!defaultRoute) {
      return true;
    }

    // Redirect to the configured route
    return this.router.parseUrl(`/${defaultRoute}`);
  }
}
